import getUserAgent from "./getUserAgent";

export default function isIe11(): boolean {
  const userAgent = getUserAgent();
  return userAgent.indexOf("Trident") > 1 && userAgent.indexOf("Windows") > -1;
}
